import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import {
  isValidQuantityInput,
  QuantityType,
} from '../models/quote-item-data.model';

export function quantityFieldValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || String(value).trim() === '') {
      return null;
    }

    const quantityType =
      (control.parent?.get('quantity_type')?.value as QuantityType) ??
      QuantityType.UNIT;

    if (isValidQuantityInput(String(value), quantityType)) {
      return null;
    }

    return { invalidQuantity: true };
  };
}
